import { render, staticRenderFns } from "./semenProduction.vue?vue&type=template&id=b2f138c6&scoped=true&"
import script from "./semenProduction.vue?vue&type=script&lang=js&"
export * from "./semenProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f138c6",
  null
  
)

export default component.exports